"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyTextToSpeechStreamingV1TextToSpeechVoiceIdStreamPostApplyTextNormalization = void 0;
exports.BodyTextToSpeechStreamingV1TextToSpeechVoiceIdStreamPostApplyTextNormalization = {
    Auto: "auto",
    On: "on",
    Off: "off",
};
